// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const meowth_alola: PokeData = {
  "id": 10107,
  "name": "meowth-alola",
  "height": 4,
  "weight": 42,
  "base_experience": 58,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "pay-day",
    "scratch",
    "bite",
    "growl",
    "screech",
    "fury-swipes",
    "slash",
    "feint-attack",
    "fake-out",
    "taunt",
    "feint",
    "assurance",
    "dark-pulse",
    "night-slash",
    "nasty-plot",
    "captivate",
    "play-rough"
  ],
  "moves": [
    "scratch",
    "bite",
    "growl",
    "dark-pulse",
    "night-slash",
    "play-rough",
    "quash",
    "night-daze",
    "pursuit",
    "crunch",
    "snatch",
    "snarl",
    "phantom-force"
  ],
  "evolution_chain": {
    "id": 22,
    "item": null,
    "species": [
      {
        "name": "meowth",
        "order": 57,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "persian",
        "order": 58,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "perrserker",
        "order": 863,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 78,
    "speed": 180,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
